import wcs from '@/scripts/libs/wcs'
import axios from 'axios'
import { WcsShippingMethod } from '@/scripts/libs/wcs/types/shipping-method'
import { getOrderIdFromDocument } from '../data'

export class WcsShippingMethods {
  static fetchShippingMethods = async function () {
    const orderId = getOrderIdFromDocument()
    const endPoint = wcs.getEndPoint('fetchShippingMethods').replace('{orderId}', orderId)
    const response = await axios.get<{ shippingMethods: WcsShippingMethod[] }>(endPoint)
    return response.data.shippingMethods
  }
}
